import { trackingPageFlowStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod";

export const getTrackingPageFlowSteps = {
  name: "getTrackingPageFlowSteps" as const,
  input: z.object({}),
  output: z.object({ steps: trackingPageFlowStepArraySchema }),
};
